// extracted by mini-css-extract-plugin
export default {"container":"ContextMenu__container--Nu1ci"};